import { render, staticRenderFns } from "./customers_table.vue?vue&type=template&id=aa8d267e&"
import script from "./customers_table.vue?vue&type=script&lang=js&"
export * from "./customers_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports